import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { FilePreviewHost } from '@proerp/ui';
import { router } from './App';
import { PortalGate } from './components/PortalGate';
import { initTheme } from './lib/theme';
import './index.css';

// Vor dem ersten Render — sonst blitzt kurz die helle Fläche auf.
initTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root-Element #root nicht gefunden.');
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <PortalGate>
        <RouterProvider router={router} />
      </PortalGate>
      {/* Einbau-Punkt der Datei-Vorschau (ADR 0075) — genau einer fürs Portal. */}
      <FilePreviewHost />
    </QueryClientProvider>
  </StrictMode>,
);
